import { AxiosError, AxiosResponse } from 'axios'
import { resolveNetworkErrorMessage } from '@labrav/common'

type ErrorBody = ErrorResponse & { message?: string }

export const getErrorMessages =
  (defaultMessages: string[]) =>
  (
    errorOrResponse?: AxiosResponse<ErrorBody> | AxiosError<ErrorBody> | null
  ) => {
    const networkMessage = resolveNetworkErrorMessage(errorOrResponse)
    if (networkMessage !== undefined) {
      return networkMessage
    }

    const response = axiosResponseFrom(errorOrResponse)
    const errorMessages = response?.data?.errors || response?.data?.message
    if (Array.isArray(errorMessages)) {
      return errorMessages.join(', ') || defaultMessages.join(', ')
    }
    return errorMessages || defaultMessages.join(', ')
  }

const axiosResponseFrom = (
  errorOrResponse?: AxiosResponse<ErrorBody> | AxiosError<ErrorBody> | null
): AxiosResponse<ErrorBody> | undefined => {
  if (!errorOrResponse) {
    return undefined
  }
  if ('isAxiosError' in errorOrResponse && errorOrResponse.isAxiosError) {
    return errorOrResponse.response
  }
  return errorOrResponse as AxiosResponse<ErrorBody>
}
